import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ChildrenOutletContexts, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, takeUntil } from 'rxjs';
import { PagesConfig } from 'src/app/core/defines/pages.config';
import { commonService } from 'src/app/core/services/common.service';
import { ItemType } from 'src/app/site/feature-modules/home/shared/components/item-type-menu/models/models';
import { UserCartService } from 'src/app/site/feature-modules/home/shared/services/user-cart.service';
import { ClientDetails } from 'src/app/site/feature-modules/profile/models/profile';
import { IBranch, ICompanyInfo } from 'src/app/site/feature-modules/welcome/models/welcome.models';
import { ItemPlace } from 'src/app/site/shared-components/item-location-overlay/models/model';
import { MenueComponent } from '../menue/menue.component';
import { SidebarModule } from 'primeng/sidebar';
import { LangDropdwonComponent } from 'src/app/site/shared-components/lang-dropdown/lang-dropdwon.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { Store } from '@ngxs/store';
import { CompanyInfoState } from 'src/app/core/store/companyInfo/company-info-state';
import { ClientDetailsState } from 'src/app/core/store/clientDetails/client-details.state';
import { AccordionModule } from 'primeng/accordion';
import { ProcessCart } from 'src/app/core/store/cart/cart.action';
import { IUserCart } from 'src/app/core/models/user-cart.model';
import { CartState } from 'src/app/core/store/cart/cart.state';
import { ComponentBase } from 'src/app/core/base/common-base';
import { AddItemCategroy } from 'src/app/core/store/services/service.action';
import { IItemCategory } from 'src/app/site/feature-modules/home/shared/components/item-categories-menu/models/item-categories.model';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MenueComponent,
    SidebarModule,
    RouterModule,
    LangDropdwonComponent,
    NgbDropdownModule,
    AccordionModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent extends ComponentBase {
  isCollapsed: boolean = false;
  companyInfo: ICompanyInfo;
  clientDetails$: Observable<ClientDetails>;
  userImage: string | null = null;
  @Input() position: 'fixed' | 'relative' | null = 'fixed';
  @Input() dir: 'ar' | 'en' = 'ar';
  cart: IUserCart | null = null;
  isMenu: boolean = false;
  isHeader: boolean = false;
  changeLangSubscription = new Subscription();
  itemPlace: ItemPlace;
  branch: IBranch | null = null;
  ItemPlaceEnum = ItemPlace;
  itemPlaceSelected: boolean;
  showItemLocationOverlay: boolean = false;
  showSearchOverlay: boolean;
  profileSidebarShow: boolean = false;
  itemTypes: ItemType[] = [];
  // isHome: boolean = false;
  currentSection: string = '';

  constructor(
    private router: Router,
    public common: commonService,
    public translate: TranslateService,
    private userCartService: UserCartService,
    private contexts: ChildrenOutletContexts,
    private store: Store,
    public translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object

  ) {
    super();
    this.getCompanyInfo();
    this.getClientDetails();
    this.getCart();
  }

  getCart() {
    this.store.select(CartState.cart).subscribe((cart) => {
      this.cart = cart
    })
  }
  getClientDetails() {
    this.clientDetails$ = this.store.select(ClientDetailsState.getClientDetails);
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Check if code is running in the browser
    if (isPlatformBrowser(this.platformId)) {
      const home = document.getElementById('home');
      const about = document.getElementById('about');
      const ourNew = document.getElementById('ourNew');
      const services = document.getElementById('services');
      const catlog = document.getElementById('catlog');
      const ourStory = document.getElementById('ourStory');
      const packages = document.getElementById('packages');


      let foundSection = false;

      if (home && home.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'home';
        foundSection = true;
      }      
      if (packages && packages.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'packages';
        foundSection = true;
      }
      if (ourStory && ourStory.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'ourStory';
        foundSection = true;
      }
      if (ourNew && ourNew.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'ourNew';
        foundSection = true;
      }
      if (catlog && catlog.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'catlog';
        foundSection = true;
      }
      if (services && services.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'services';
        foundSection = true;
      }
      if (about && about.getBoundingClientRect().top < window.innerHeight / 6) {
        this.currentSection = 'about';
        foundSection = true;
      }
      if (!foundSection) {
        this.currentSection = '';
      }
    }
  }
  isFilterService: boolean = false
  navigate(path: string, elementId: string = '', filter: boolean = false): void {
    if (this.router.url !== '/') {
      this.router.navigate([path]);
      this.isHeader = false;
    }
    if (!elementId) return
    setTimeout(() => this.scrollToElement(elementId));
    if(filter){
      const ItemCategory:IItemCategory = {
        id: 51679,
        name: '',
        icon: '',
        nonSelectedImage: '',
        selectedImage: ''
      }
      this.store.dispatch(new AddItemCategroy(ItemCategory));
      this.isFilterService = true;
    }else{
      this.store.dispatch(new AddItemCategroy(null));
    this.isFilterService = false;
    }
  }
  logIn(): void {
    this.router.navigate([PagesConfig.login]);
    this.isHeader = false;
  }
  // changeLanguage(lang: string) {
  //   this.translateService.use(lang);
  //   window.location.reload();
  // }
  public changeLanguage(language: string): void {
    this.translateService.use(language);

    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.reload();
      });
  }

  public reload(): void {
    window.location.reload();
  }
  prepareRoute() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
  logout(): void {
    // this.userCartService.setUserCart(null);
    this.store.dispatch(new ProcessCart(null));
    this.common.logOut();
    window.location.reload();
  }
  getCompanyInfo() {
    this.store.select(CompanyInfoState.getCompanyInfo).subscribe((info) => {
      if (!info) return;
      this.companyInfo = info;
    });
  }
}
